//Paquetes NPM de GYF.
import { Mediator } from "com-gyf-webcore-mediator";
import { LogHelper } from "com-gyf-webcore-loghelper";
import React from 'react';
import ReactDOM from 'react-dom';
import { Engine1Proxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
//Seteo de apiUrl
import AtlasManager from '../../../Common/Managers/AtlasManager';
//Helper html
import HtmlMapper from "../../../Common/Helpers/HtmlMapper";

import CustomPrompt from "../../../Common/Components/CustomPrompt";

export const GET_DATA_INSTANCIA_PARAMETROS = "GET_DATA_INSTANCIA_PARAMETROS";
export const AGREGAR_EQUIVALENCIA = "AGREGAR_EQUIVALENCIA";
export const ELIMINAR_EQUIVALENCIA = "ELIMINAR_EQUIVALENCIA";
export const ACTUALIZAR_EQUIVALENCIA = "ACTUALIZAR_EQUIVALENCIA";
export const ACTUALIZAR_INSTANCIA = "ACTUALIZAR_INSTANCIA";
export const LIMPIAR_ESTADO_ATLAS = "LIMPIAR_ESTADO_ATLAS";
export const LIMPIAR_ESTADO_NUEVA_INSTANCIA = "LIMPIAR_ESTADO_NUEVA_INSTANCIA";
export const GUARDAR_INSTANCIA_PARAMETRO = "GUARDAR_INSTANCIA_PARAMETRO";
export const VALIDAR_INSTANCIA_PARAMETRO = "VALIDAR_INSTANCIA_PARAMETRO";
export const MOSTRAR_SPINNER_GUARDADO = "MOSTRAR_SPINNER_GUARDADO";
export const FINALIZAR_GUARDADO = "FINALIZAR_GUARDADO";
export const CAMBIAR_ACTIVO_INSTANCIA_PARAMETRO = "CAMBIAR_ACTIVO_INSTANCIA_PARAMETRO";
export const ERROR_MODAL_POST_VALIDADOR = "ERROR_MODAL_POST_VALIDADOR";
export const SET_ES_ALTA_INSTANCIA = "SET_ES_ALTA_INSTANCIA";
export const ACTUALIZAR_SUBEQUIVALENCIA = "ACTUALIZAR_SUBEQUIVALENCIA";

let _dispatch = undefined;
let _state = undefined;
let esEdicion = undefined;

/**
 * 
 * @param {any} currentScope
 * @param {any} objEntidad
 */
export function obtenerInformacionPantalla(currentScope) {
    LogHelper.In(obtenerInformacionPantalla.name, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _obtenerInformacionPantallCallback(data, getState().atlas), null, "GETFUNCTIONS", currentScopeRequest);
    }
}
/**
 * 
 */
export function agregarEquivalencia() {
    LogHelper.In(agregarEquivalencia.name);

    return (dispatch) => {
        dispatch({ type: AGREGAR_EQUIVALENCIA });
    }
}
/**
 * 
 * @param {any} idEquivalenciaInstancia
 * @param {any} idEquivalencia
 * @param {any} valorEquivalencia
 */
export function actualizarEquivalencia(idEquivalenciaInstancia, idEquivalencia, valorEquivalencia) {
    LogHelper.In(actualizarEquivalencia.name, idEquivalenciaInstancia, idEquivalencia, valorEquivalencia);

    return (dispatch, getState) => {
        dispatch({ type: ACTUALIZAR_EQUIVALENCIA, idEquivalenciaInstancia, idEquivalencia, valorEquivalencia });

        let stateAtlas = getState().atlas;
        const { data } = _realizarValidaciones(getState().nuevaInstanciaParametro, stateAtlas);
        let huboError = data.huboError;

        if(huboError) {
            dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError, seEstaGuardando: false });
        }
    }
}
/**
 * 
 * @param {any} id
 */
export function eliminarEquivalencia(id) {
    LogHelper.In(eliminarEquivalencia.name, id);
    
    return (dispatch, getState) => {
        dispatch({ type: ELIMINAR_EQUIVALENCIA, id });

        let stateAtlas = getState().atlas;
        const { data } = _realizarValidaciones(getState().nuevaInstanciaParametro, stateAtlas);
        let huboError = data.huboError;

        dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError, seEstaGuardando: false });
        

    }
}
/**
 * 
 * @param {any} codigo
 * @param {any} valor
 * @param {any} validacion
 */
export function actualizarParametro(codigo, valor) {
    LogHelper.In(actualizarParametro.name, codigo, valor);

    return (dispatch) => {
        dispatch({ type: ACTUALIZAR_INSTANCIA, codigo, valor });
    }
}
/**
 * 
 */
export function reiniciarEstado() {
    LogHelper.In(reiniciarEstado.name);

    return (dispatch) => {
        dispatch({ type: LIMPIAR_ESTADO_NUEVA_INSTANCIA });
        dispatch({ type: LIMPIAR_ESTADO_ATLAS });
    }
}

export function cambiarActivoInstanciaParametro() {
    return (dispatch, getState) => {
        let stateNuevaInstancia = getState().nuevaInstanciaParametro.data;
        // let instancias = JSON.parse(JSON.stringify(stateNuevaInstancia.instancias));
        //Prueba logs Automation
        let instancias
        try {
            instancias = JSON.parse(JSON.stringify(stateNuevaInstancia.instancias));
            instancias.map(i => i.Activo = !i.Activo);

            dispatch({ type: CAMBIAR_ACTIVO_INSTANCIA_PARAMETRO, instancias });
        } catch (error) {
            console.log("Fallo Actions.js Linea 117. Data recibida: " + JSON.stringify(stateNuevaInstancia.instancias));
        }
        //Fin logs automation
    }
}

/**
 * 
 */
export function guardarNuevaInstanciaParametro() {
    LogHelper.In(guardarNuevaInstanciaParametro.name);

    return (dispatch, getState) => {
        let stateNuevaInstancia = getState().nuevaInstanciaParametro;
        let stateAtlas = getState().atlas;
        esEdicion = stateAtlas.entidadInstanciaId;
        const { data } = _realizarValidaciones(getState().nuevaInstanciaParametro, stateAtlas);
        _dispatch = dispatch;
        let huboError = data.huboError;
        let seEstaGuardando = !huboError;
        let postValidador = stateNuevaInstancia?.data?.postValidador;

        if (!huboError) {
            _state = data;
            let answer = _validarCodigoRepetido(stateNuevaInstancia);
            if (answer.length > 0) {
                let mensaje = generarMensajeCodigoRepetido(answer);
                getUserConfirmation(mensaje, callbackRta);
            } else {
                dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError, seEstaGuardando });
                if (sessionStorage.getItem('PantallaCambios') == "true") {
                    sessionStorage.removeItem('PantallaCambios');
                }

                //Validación de post-validadores
                if(postValidador) {
                    /* Se genera un diccionario con todas las propiedades y valores de la instancia a dar de alta/editar. Tanto el DS como
                    el SP deben tener definidos como parámetros de entrada todas las propiedades de la Entidad, por más que no se utilicen todas
                    las propiedades para validar */

                    let paramsPostValidador = Object.assign({}, ...stateNuevaInstancia.data.instancias.map(x => ({[x.Codigo.toUpperCase()]: x.Valor})));

                    LogHelper.Out(guardarNuevaInstanciaParametro.name, null, postValidador, 'Get', 'Atlas', 'Atlas', 1, 'Product');
                    Engine1Proxy.AddDataSourcesRequests(paramsPostValidador, postValidador, 'Get', 'Atlas', 'Atlas', 1, 'Product');

                    Engine1Proxy.Execute((data) => _postValidadorCallBack(data, _state, postValidador));
                } else {
                    AtlasManager.GuardarInstancias(_state, SagasHelper.GetSagasId, callBackGuardarInstancia)
                }
            }
        }
        dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError, seEstaGuardando });
    }
}


function _postValidadorCallBack(data, state, postValidador) {
    let mensajeError = JSON.parse(data[postValidador]).Recordset0.Rows[0].MensajeError;
    let validacionOk = mensajeError == null;


    validacionOk ?
        AtlasManager.GuardarInstancias(state, SagasHelper.GetSagasId, callBackGuardarInstancia)
    :
        _dispatch({ type: ERROR_MODAL_POST_VALIDADOR, mostrarModal: true, mensaje: mensajeError });
}

export function ocultarMostrarModalPostValidador(mostrarModal) {
    LogHelper.In(ocultarMostrarModalPostValidador.name);

    return (dispatch) => {
        _dispatch({ type: ERROR_MODAL_POST_VALIDADOR, mostrarModal, mensaje: null });
        _dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError: false, seEstaGuardando: false });
    }
}

function generarMensajeCodigoRepetido(answer) {
    let msjCodigosDescr = [];
    for (let index = 0; index < answer.length; index++) {
        let descr = answer[index].Descripcion.toString() != "" ? "-" + answer[index].Descripcion.toString() : "";

        let objMsj = {
            "Mensaje": answer[index].Codigo.toString() + descr
        }
        msjCodigosDescr.push(objMsj);
    }

    const mensaje = msjCodigosDescr.map(function (row) {
        return <li>{row.Mensaje}</li>
    })
    return mensaje;
}

const getUserConfirmation = (message, callback) => {
    const modal = document.createElement('div')
    document.body.appendChild(modal)

    const withCleanup = (answer) => {
        ReactDOM.unmountComponentAtNode(modal)
        document.body.removeChild(modal)
        callback(answer)
    }

    const headerMessage = "Advertencia";

    ReactDOM.render(<CustomPrompt codigoRepetidos={true} message={message} withCleanup={withCleanup} headerMessage={headerMessage} />, modal);
}

function callbackRta(answer) {
    if (answer) {
        _dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError: false, seEstaGuardando: true });
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios');
        }
        AtlasManager.GuardarInstancias(_state, SagasHelper.GetSagasId, callBackGuardarInstancia);
    } else {
        _dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError: false, seEstaGuardando: false });
    }
}

export function mostrarSpinner() {
    LogHelper.In(mostrarSpinner.name);

    return (dispatch) => {
        dispatch({ type: MOSTRAR_SPINNER_GUARDADO });
    }
}

export function finalizarSaga() {
    LogHelper.In(finalizarSaga.name);

    return (dispatch) => {
        dispatch({ type: FINALIZAR_GUARDADO });

    }
}
/*Funciones auxiliares*/

//Funcion para validar que la fecha exista en el calendario
function _validarFechaReal(fecha) {
    if (fecha) {
        let fechaf = fecha.split("-");
        let d = fechaf[0];
        let m = fechaf[1];
        let a = fechaf[2];
        return m > 0 && m < 13 && a > 0 && a < 32768 && d > 0 && d <= (new Date(a, m, 0)).getDate();
    } else {
        return null;
    }
}

function _validarHora(tiempo) {
    let time = tiempo.split(':');
    let tiempoValido = true;

    let hora = parseInt(time[0]);
    let min = parseInt(time[1]);
    let seg = parseInt(time[2]);

    tiempoValido = !hora ? tiempoValido : hora >= 0 && hora < 24 ? tiempoValido : false;

    if (tiempoValido)
        tiempoValido = !min ? tiempoValido : min >= 0 && min < 60 ? tiempoValido : false;
    
    if (tiempoValido)
        tiempoValido = !seg ? tiempoValido : seg >= 0 && seg < 60 ? tiempoValido : false;
    
    return tiempoValido;
}

function _validarCodigoRepetido(state) {
    let codigosRepetidos = [];
    let codigoValor = null;
    let codigoActual = state.data.instancias.find(x => x.Codigo == 'CODIGO');
    let entidadInstanciaIdActual = state.data.instancias[0].EntidadInstanciaId;

    if (codigoActual != null) {
        codigoValor = codigoActual.Valor;
    }

    if (!Number.isNaN(Number(codigoValor))) {
        let valorConvertido = Number(codigoValor);
        //Es numeric
        state.data.instanciaPropiedades.filter(x => x.Codigo == "CODIGO").forEach((ins2) => {
            const valorFilter = ins2.Valor ? ins2.Valor.toLowerCase().trim() : "";
            let entidadInstanciaIdAux = ins2.EntidadInstanciaId;
            if (valorConvertido == Number(valorFilter) && entidadInstanciaIdAux != entidadInstanciaIdActual) {
                //Verifico si la entidad presenta la propiedad DESCRIPCION por error al momento de generar el mensaje de validación. Bug UAAD17-1411
                let variable = state.data.instanciaPropiedades.filter(x => x.EntidadInstanciaId == ins2.EntidadInstanciaId && x.Codigo == "DESCRIPCION");

                let codigoDescripcion = {
                    "Codigo": ins2.Valor,
                    "Descripcion": variable.length > 0 ? variable[0].Valor : ""//state.data.instanciaPropiedades.filter(x => x.EntidadInstanciaId == ins2.EntidadInstanciaId && x.Codigo == "DESCRIPCION")[0].Valor
                }

                codigosRepetidos.push(codigoDescripcion);
            }
        });
    }
    return codigosRepetidos;
}

function callBackGuardarInstancia(result, disconnectCallback) {
    LogHelper.In(callBackGuardarInstancia.name, result, disconnectCallback);

    _dispatch({ type: GUARDAR_INSTANCIA_PARAMETRO, sagaId: result.SagaId, estadoId: result.Estado, esEdicion: esEdicion });
    disconnectCallback();
}


/**
 * 
 * @param {any} data
 */
function _obtenerInformacionPantallCallback(data, dataAtlas) {
    LogHelper.In(_obtenerInformacionPantallCallback.name, dataAtlas);

    let idEntidad = {
        "ENTIDAD_ID": dataAtlas.entidadId
    }

    let params = {
        "ENTIDAD_ID": dataAtlas.entidadId,
        "ENTIDAD_INSTANCIA_ID": ((dataAtlas.entidadInstanciaId) ? dataAtlas.entidadInstanciaId : 0)
    }

    LogHelper.Out(_obtenerInformacionPantallCallback.name, idEntidad, 'GET_PROPIEDAD_INSTANCIA_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(idEntidad, 'GET_PROPIEDAD_INSTANCIA_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    LogHelper.Out(_obtenerInformacionPantallCallback.name, params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_EQUIVALENCIAS', 'Get', 'Atlas', 'Atlas', 1, 'Product');

    Engine1Proxy.Execute((data) => {
        const nuevaData = {
            nombreEntidad: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].NombreEntidad,
            codigoEntidad: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].Codigo,
            generoEntidad: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].Genero,
            requiereEquivalencia: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].RequiereEquivalencia,
            postValidador: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].PostValidador,
            instancias: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset1.Rows,
            instanciaEquivalencias: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset2.Rows,
            equivalencias: JSON.parse(data.GET_EQUIVALENCIAS).Recordset0.Rows,
            instanciaPropiedades: JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID).Recordset0.Rows,
            requiereSubequivalencia: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].RequiereSubequivalencia,
            subEquivalencias: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset3.Rows
        }

        _obtenerEntidadRelacionada(nuevaData);
    });
}

function _convertirFechaDB(data) {

    data.map((propiedad, i) => {

        if (propiedad.TipoCodigo == 'DATETIME' && propiedad.Valor != null) {

            let fechaAux = propiedad.Valor.split('-')
            let fecha1 = ""
            let fecha2 = ""
            let mes = fechaAux[0].length > 1 ? fechaAux[0] : "0" + fechaAux[0]
            let dia = fechaAux[1].length > 1 ? fechaAux[1] : "0" + fechaAux[1]
            //fecha1 += mes + "-" + dia + "-" + fechaAux[2]
            fecha2 += dia + "-" + mes + "-" + fechaAux[2]

            propiedad.Valor = fecha2;
        }
    });
}

function _obtenerEntidadRelacionada(dataInstanciaParametro) {
    LogHelper.In(_obtenerEntidadRelacionada.name, dataInstanciaParametro);

    let ejecutarRequests = false;
    let esAltaInstancia = dataInstanciaParametro?.instancias?.map(x => x.Valor).filter(x => x).length == 0;

    _dispatch({ type: SET_ES_ALTA_INSTANCIA, esAltaInstancia });

    _convertirFechaDB(dataInstanciaParametro.instancias);

    dataInstanciaParametro.instancias.forEach((ins, index) => {
        if (ins.EntidadRelacionadaId) {
            ejecutarRequests = true;

            let params = { "ENTIDAD_ID": ins.EntidadRelacionadaId, "PROPIEDAD_ID": ins.PropiedadId }

            LogHelper.Out(_obtenerEntidadRelacionada.name, (params, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID", "Get", "Atlas", "Atlas", 1, "Product",
                true, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID_" + index));
            Engine1Proxy.AddDataSourcesRequests(params, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID", "Get", "Atlas", "Atlas", 1, "Product",
                true, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID_" + index);
        }
    })

    if (ejecutarRequests) {
        Engine1Proxy.Execute((data) => {
            Object.keys(data).forEach(o => {
                if (o.indexOf("GET_ENTIDAD_RELACIONADA_BY_ENTIDADID_") >= 0) {
                    const result = JSON.parse(data[o]).Recordset0.Rows;

                    dataInstanciaParametro.instancias.forEach((ins) => {
                        if (result.length > 0 && ins.Codigo == result[0].CodigoPropiedad) {
                            ins.entidadRelacionada = result;
                        }
                    });
                }
            });
            _dispatch({ type: GET_DATA_INSTANCIA_PARAMETROS, dataInstanciaParametro });
        });
    } else {
        _dispatch({ type: GET_DATA_INSTANCIA_PARAMETROS, dataInstanciaParametro });
    }
}
/**
 * 
 * @param {any} state
 */



function validarValoresUnCaracter(ins) {
    let codigosUnCaracter = ["EMPRESAINDIVIDUOS", "TIPOLIMITE", "MONEDALIMITECOMPRA", "ALCANCE", "TIPOPLASTICO",
        "TIPOPERSONA", "INDIVIDUOSEMPRESA", "TIPOPERSONA"];
    let rst = false;
    codigosUnCaracter.map((cod) => {
        if (cod == ins.Codigo)
            rst = true;
    });

    return rst;
}

function _realizarValidaciones(state, stateAtlas) {
    LogHelper.In(_realizarValidaciones.name, state);

    let huboError = false;
    let propiedades = state.data.instanciaPropiedades;
    //Se obtiene el nombre de la entidad para validar la descripción de la instancia siempre y cuando no sea de la entidad FERIADO. Bug UAAD17-1364
    let entidad = state.data.codigoEntidad;

    const entidadInstanciaIdElegida = (stateAtlas.entidadInstanciaId || 0);


    /*Filtro por aquellos que sean obligatorios para realizar las validaciones*/
    state.data.instancias.filter((ins1 => ins1.EstaVisible && ins1.Obligatorio)).forEach((ins2) => {
        //Eliminar espacios en blanco siempre y cuando el valor no sea null. Bug UAAD17-1235
        if (ins2.Valor != null) {
            //Si se completan los input con espacios en blanco se eliminan para poder validarlo correctamente. Bug UAAD17-1225
            ins2.Valor = typeof ins2.Valor === "string" ? ins2.Valor.trim() : ins2.Valor
        }

        const tipoElemento = HtmlMapper.ObtenerTipoElemento(ins2.TipoCodigo);

        if (tipoElemento.esInputText) {
            if (validarValoresUnCaracter(ins2)) {
                ins2.Valor = ins2.Valor && typeof ins2.Valor === "string" ? ins2.Valor.toString().toUpperCase() : ins2.Valor
            }
        }

        //valido que el campo CODIGO no tenga espacios
        if (ins2.Codigo == "CODIGO") {
            if (ins2.Valor && ins2.Valor.includes(" ")) {
                huboError = true;
                ins2.esValido = false;
                ins2.mensajeError = "El campo código solo se permite caracteres alfanuméricos.";
            }
        }

        /*Se modifica el valor del "Seleccione..." a "-1" para integrar el valor "Todos/as" al combo - AD17-1349 */
        if (tipoElemento.esSelect && (!ins2.Valor || ins2.Valor == "-1")) {
            huboError = true;
            ins2.esValido = false;
            ins2.mensajeError = "Por favor, debe seleccionar una opción";
        }

        if ((tipoElemento.esInputText || tipoElemento.esInputDate) && (!ins2.Valor || ins2.Valor == "")) {
            huboError = true;
            ins2.esValido = false;
            ins2.mensajeError = `Por favor, debe completar el campo ${ins2.Descripcion}`;
        } else {
            if ((tipoElemento.esInputText || tipoElemento.esInputDate) && ins2.Regexp && ins2.Regexp != "") {
                if (!new RegExp(ins2.Regexp).test(ins2.Valor) && !ins2.mensajeError) {
                    huboError = true;
                    ins2.esValido = false;
                    /*Seteo el valor del mensaje en caso de que el formato no sea el correcto*/
                    ins2.mensajeError = `El campo ${ins2.Descripcion} no posee un formato correcto`;
                }
            }

            //Se contempla el campo FECHA para la entidad FERIADO para validar la preexistencia de una fecha igual a la ingresada. Bug UAAD17-1217
            //Si hubo un error por formato incorrecto de FECHA no realizar las validaciones posteriores. Bug UAAD17-1217
            if ((ins2.Codigo == "CODIGO" || ins2.Codigo == "DESCRIPCION" || ins2.Codigo == "FECHA") && !huboError) {
                let valorFilter = null;

                if (ins2.Codigo == "FECHA") {
                    let fechaAux = ins2.Valor.toLocaleLowerCase().trim().split('-');
                    let mes = fechaAux[1].length > 1 ? fechaAux[1] : "0" + fechaAux[1];
                    let dia = fechaAux[0].length > 1 ? fechaAux[0] : "0" + fechaAux[0];

                    valorFilter = mes + "-" + dia + "-" + fechaAux[2];
                }
                else {
                    valorFilter = ins2.Valor.toLocaleLowerCase().trim();
                }

                let codigoEncotrado = propiedades.find(function (x) {
                    if (x.Codigo == "CODIGO" && x.Valor != undefined && x.Valor.toLocaleLowerCase().trim() == valorFilter) {
                        return x;
                    }
                });

                let descripcionEncontrado = propiedades.find(function (x) {
                    //Solo se valida la descripción siempre y cuando la entidad no sea FERIADO. UAAD17-1364
                    if (x.Codigo == "DESCRIPCION" && x.Valor != undefined && x.Valor.toLocaleLowerCase().trim() == valorFilter && entidad != "FERIADO") {
                        return x;
                    }
                });

                let fechaEncontrado = propiedades.find(function (x) {
                    if (x.Codigo == "FECHA" && x.Valor != undefined && x.Valor.toLocaleLowerCase().trim() == valorFilter) {
                        return x;
                    }
                });

                let existeCodigo = ((codigoEncotrado != undefined) ? ((codigoEncotrado.EntidadInstanciaId == entidadInstanciaIdElegida) ? false : true) : false)
                let existeDescripcion = ((descripcionEncontrado != undefined) ? ((descripcionEncontrado.EntidadInstanciaId == entidadInstanciaIdElegida) ? false : true) : false)
                let existeFecha = ((fechaEncontrado != undefined) ? ((fechaEncontrado.EntidadInstanciaId == entidadInstanciaIdElegida) ? false : true) : false)

                if (existeCodigo || existeDescripcion || existeFecha) {

                    huboError = true;
                    ins2.esValido = false;
                    ins2.mensajeError = `El campo ${ins2.Descripcion} ya existe.`;
                }
            }
        }

        //valido si la fecha es real
        if (ins2.TipoCodigo == "DATETIME" && ins2.Valor && !ins2.mensajeError) {
            let fecha = ins2.Valor;
            let hora = null;

            if(ins2.Valor.trim().length > 10) {
                fecha = ins2.Valor.substr(0,10);
                hora = ins2.Valor.substr(10,10).trim();
            }

            if (!_validarFechaReal(fecha)) {
                huboError = true;
                ins2.esValido = false;
                ins2.mensajeError = "La fecha ingresada no se encuentra en el calendario.";
            }

            if (hora && !huboError && !_validarHora(hora)) {
                huboError = true;
                ins2.esValido = false;
                ins2.mensajeError = "La hora ingresada contiene un valor inválido.";
            }
        }

        if (ins2.Codigo == "FECHACIERRE") {
            let carteraId, cierreCartera
            state.data.instancias.filter((ins => ins.EstaVisible && ins.Obligatorio)).forEach((instancia) => {
                if (instancia.Codigo == "CARTERAID") {
                    carteraId = instancia.Valor;
                }
                if (instancia.Codigo == "FECHACIERRE") {
                    cierreCartera = instancia.Valor;
                }
            })

            if (validarCarterasCargadas(propiedades, carteraId, cierreCartera)) {
                huboError = true;
                ins2.esValido = false;
                ins2.mensajeError = `La cartera seleccionada ya cuenta con fecha de vencimiento ${cierreCartera}`;
            }
        }

        if (!huboError) {
            delete ins2.esValido;
        }
    });


    //Agregar validaciones de equivalencia-subequivalencia y código
    state.data.instanciaEquivalencias.forEach((ins, index) => {
        ins.ValorEquivalencia = ins.ValorEquivalencia.trim();
        let codigoRepetido = state.data.instanciaEquivalencias.some((e, eqIndex) => eqIndex != index &&
                                                                                      !e.DeleteInstance &&
                                                                                      e.IdEquivalencia == ins.IdEquivalencia);

        if(state.data.requiereSubequivalencia) {
            codigoRepetido = state.data.instanciaEquivalencias.some((e, eqIndex) => eqIndex != index &&
                                                                                      !e.DeleteInstance &&
                                                                                      e.IdEquivalencia == ins.IdEquivalencia && 
                                                                                      e.SubequivalenciaId == ins.SubequivalenciaId && 
                                                                                      e.ValorEquivalencia == ins.ValorEquivalencia && 
                                                                                      e.ValorEquivalencia.trim() != "");
        }
        
        let subequivalenciaRepetida = state.data.requiereSubequivalencia ? state.data.instanciaEquivalencias.filter((e, eqIndex) => eqIndex != index && 
                                                                                                                                    !e.DeleteInstance &&
                                                                                                                                    e.IdEquivalencia != "0" &&
                                                                                                                                    ins.IdEquivalencia != "0" &&
                                                                                                                                    e.IdEquivalencia == ins.IdEquivalencia && 
                                                                                                                                    e.SubequivalenciaId == ins.SubequivalenciaId).length > 0
                                                                         : false;

        if (ins.IdEquivalencia == 0 || ins.ValorEquivalencia == "" || !ins.ValorEquivalencia) {
            huboError = true;
            ins.huboError = true;
        } else {
            ins.huboError = false;
        }

         // Si se ingresó el mismo código bajo la misma Equivalencia-Subequivalencia
        if ((codigoRepetido || subequivalenciaRepetida) && !ins.DeleteInstance) {
            huboError = true;
            ins.errorCodigoRepetido = !subequivalenciaRepetida;
        } else {
            ins.errorCodigoRepetido = false;
        }
        //Si se ingresó el mismo código de Subequivalencia bajo la misma Equivalencia
        if(subequivalenciaRepetida && !ins.DeleteInstance) {
            huboError = true;
            ins.errorSubequivalenciaRepetida = true;
        } else {
            ins.errorSubequivalenciaRepetida = false;
        }
    });

    //carga de propiedades opcioneales que no pueden ser null
    state.data.instancias.filter((ins1 => ins1.EstaVisible && !ins1.Obligatorio)).forEach((ins2) => {
        const tipoElemento = HtmlMapper.ObtenerTipoElemento(ins2.TipoCodigo);

        //Se valida para las propiedades opcionales también. Bug UAAD17-1234
        if (tipoElemento.esInputText) {
            if (validarValoresUnCaracter(ins2))
                ins2.Valor = ins2.Valor && typeof ins2.Valor === "string" ? ins2.Valor.toString().toUpperCase() : ins2.Valor
        } {

        }

        if (tipoElemento.esSelect && ins2.Valor == "-1") {
            ins2.Valor = null;
        }

        if ((tipoElemento.esInputText || tipoElemento.esInputDate) && ins2.Regexp && ins2.Regexp != "" && ins2.Valor != null && ins2.Valor != "") {
            if (!new RegExp(ins2.Regexp).test(ins2.Valor)) {
                huboError = true;
                ins2.esValido = false;
                /*Seteo el valor del mensaje en caso de que el formato no sea el correcto*/
                ins2.mensajeError = `El campo ${ins2.Descripcion} no posee un formato correcto`;
            }
        }

        if ((tipoElemento.esInputDate && ins2.Codigo == "FECHAVENCIMIENTO") && ins2.Regexp && ins2.Regexp != "" && ins2.Valor != null && ins2.Valor != "") {
            state.data.instancias.filter((ins => ins.EstaVisible && ins.Obligatorio)).forEach((instancia) => {
                if (instancia.Codigo == "FECHACIERRE") {

                    if (_validarFechaCartera(instancia.Valor, ins2.Valor)) {
                        huboError = true;
                        ins2.esValido = false;
                        ins2.mensajeError = `${ins2.Descripcion} debe ser posterior o igual a la FECHA DE CIERRE DE CARTERA`;
                    }
                }
            });
        }

        if (!huboError) {
            delete ins2.esValido;
            huboError = false;
        }
    });

    return {
        ...state,
        data: {
            ...state.data,
            huboError
        }
    };
}

function validarCarterasCargadas(propiedades, carteraId, cierreCartera) {
    let fechaCarteraAsiganda = false;
    let instanciasUnicas = propiedades.filter((pinst, index, self) => {
        return self.map((s) => s.EntidadInstanciaId).indexOf(pinst.EntidadInstanciaId) == index
    })
    instanciasUnicas.forEach((instUnica, index) => {
        let propiedadesEncontradas = propiedades.filter((pinst) => pinst.EntidadInstanciaId == instUnica.EntidadInstanciaId);
        if (propiedadesEncontradas) {
            let fechaCartera = getFormatoFecha(propiedadesEncontradas[1].Valor);
            let carteraSeleccionId = propiedadesEncontradas[3].Valor;
            if (fechaCartera == cierreCartera && carteraId == carteraSeleccionId)
                fechaCarteraAsiganda = true;
        }
    })
    return fechaCarteraAsiganda;
}

function getFormatoFecha(fecha) {
    let fechaAux;
    if (fecha) {
        fechaAux = fecha.split('-');
        fechaAux = fechaAux[1] + '-' + fechaAux[0] + '-' + fechaAux[2]
    }
    return fechaAux;
}

function _validarFechaCartera(fCierre, fVencimiento) {

    let errorFecha = false;
    let fechaAuxCierre = fCierre.split('-')
    let fechaCierre;
    let diaCierre = fechaAuxCierre[0].length > 1 ? fechaAuxCierre[0] : "0" + fechaAuxCierre[0]
    let mesCierre = fechaAuxCierre[1].length > 1 ? fechaAuxCierre[1] : "0" + fechaAuxCierre[1]
    let anioCierre = fechaAuxCierre[2].length > 1 ? fechaAuxCierre[2] : "0" + fechaAuxCierre[2]
    fechaCierre = new Date(anioCierre, mesCierre, diaCierre);

    let fechaAuxVencimiento = fVencimiento.split('-')
    let fechaVencimiento;
    let diaVencimiento = fechaAuxVencimiento[0].length > 1 ? fechaAuxVencimiento[0] : "0" + fechaAfechaAuxVencimientouxCierre[0]
    let mesVencimiento = fechaAuxVencimiento[1].length > 1 ? fechaAuxVencimiento[1] : "0" + fechaAuxVencimiento[1]
    let anioVencimiento = fechaAuxVencimiento[2].length > 1 ? fechaAuxVencimiento[2] : "0" + fechaAuxVencimiento[2]
    fechaVencimiento = new Date(anioVencimiento, mesVencimiento, diaVencimiento)

    if (fechaVencimiento < fechaCierre) {
        errorFecha = true;
    }
    return errorFecha;
}


export function actualizarSubEquivalencia(idEquivalenciaInstancia, idSubEquivalencia, codigoSubequivalencia) {
    LogHelper.In(actualizarSubEquivalencia.name, idEquivalenciaInstancia, idSubEquivalencia, codigoSubequivalencia);

    return (dispatch, getState) => {
        dispatch({ type: ACTUALIZAR_SUBEQUIVALENCIA, idEquivalenciaInstancia, idSubEquivalencia, codigoSubequivalencia });
        
        let stateAtlas = getState().atlas        
        const { data } = _realizarValidaciones(getState().nuevaInstanciaParametro, stateAtlas);
        const huboError = data.huboError; 

        if(huboError) {
            dispatch({ type: VALIDAR_INSTANCIA_PARAMETRO, huboError, seEstaGuardando: false });
        }
    };
}
